import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {MessageService} from "../../../../messages/message.service";
import {AuthService} from "../../../auth.service";
import {HtmlUtilsService} from "../../../../html-utils/html-utils.service";

@Component({
  selector: 'app-password-prompt',
  templateUrl: './password-prompt.component.html',
  styleUrls: ['./password-prompt.component.scss']
})
export class PasswordPromptComponent implements OnInit {

  modalTitle: string;

  modalQuestion: string;

  password: string = '';

  private beforeFunc: (boolean) => void;

  private beforeFuncArg: boolean;

  setLabels(args: { modalTitle: string, modalQuestion: string }) {
    this.modalTitle = args.modalTitle;
    this.modalQuestion = args.modalQuestion;
  }

  constructor(public activeModal: NgbActiveModal,
              private messageService: MessageService,
              private authService: AuthService,
              private htmlUtils: HtmlUtilsService) {
  }

  ngOnInit() {
  }

  closeModal() {
    this.activeModal.close(false);
  }

  removeAccount() {
    this.authService.getToken().then(token => {
      this.authService.deleteAccount(token).subscribe(() => {
        this.authService.forgetUser();
        this.authService.logout();
        this.activeModal.close(true);
      }, () => {
        this.closeModal();
      })
    });
  }
}
